export default {
  create: 'Crear departamento'
}
